import { useEffect, useRef } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Message } from "@/components/ai/types";
import { ChatMessage } from "@/components/ai/ChatMessage";
import { TypingIndicator } from "./TypingIndicator";

interface ChatMessageListProps {
  messages: Message[];
  showTypingIndicator?: boolean;
}

export const ChatMessageList = ({ messages, showTypingIndicator = false }: ChatMessageListProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  
  // Filter out orchestration status messages
  const filteredMessages = messages.filter(message => {
    // Keep user messages
    if (message.sender === "user") return true;
    
    // Filter out orchestration status messages that contain these phrases
    const orchestrationPhrases = [
      "I'll handle this request",
      "I'll coordinate",
      "coordinating multiple",
      "coordinate the right specialized",
      "Let me coordinate",
      "I'll use an adaptive orchestration",
      "This appears to be a complex request",
      "direct agent-to-agent communication"
    ];
    
    // Keep the message if it doesn't contain any of the orchestration phrases
    return !orchestrationPhrases.some(phrase => 
      message.content.toLowerCase().includes(phrase.toLowerCase())
    );
  });

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (scrollRef.current) {
      const scrollElement = scrollRef.current;
      scrollElement.scrollTop = scrollElement.scrollHeight;
    }
  }, [messages, showTypingIndicator]);

  return (
    <ScrollArea ref={scrollRef} className="flex-1 p-4">
      <div className="space-y-4 pb-4">
        {filteredMessages.map((message) => (
          <ChatMessage key={message.id} message={message} />
        ))}
        
        {showTypingIndicator && (
          <div className="pt-2">
            <TypingIndicator />
          </div>
        )}
      </div>
    </ScrollArea>
  );
};
